export default {
      id: "ic_insta-usage",
      viewBox: "0 0 40 40",
      url: "../../../plugins/creasit-builder/assets/dist/images/" + "sprite.svg#ic_insta-usage",
      toString: function () {
        return this.url;
      }
    }